import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Globals} from '../globals';

const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    })
  };

@Injectable()
export class DocumentCategoryService {
    apiUrl = Globals.apiUrl;
    constructor(private http: HttpClient) {}

     GetDocumentCategoryList(value) {
      return this.http.post<any>(
        this.apiUrl + 'CommonService/GetDocumentCategoryList',
        value,
        httpOptions
      );
    }

    CreateDocumentCategory(value) {
      return this.http.post<any>(
        this.apiUrl + 'CommonService/CreateDocumentCategory',
        value,
        httpOptions
      );
    }

    UpdateDocumentCategory(value) {
      return this.http.post<any>(
        this.apiUrl + 'CommonService/UpdateDocumentCategory',
        value,
        httpOptions
      );
    }

     GetDocumentCategoryById(value) {
      return this.http.post<any>(
        this.apiUrl + 'CommonService/GetDocumentCategoryById',
        value,
        httpOptions
      );
    }
  }
